import { useEffect, useState } from "react";
import {
  Box,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  useTheme,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import React from "react";
import { People, Store, SupportAgent } from "@mui/icons-material";

export interface ModuleMenuItemProps {
  handleDrawerClose: () => void;
  closeMenu: boolean;
}
interface IModuleActions {
  icon: string;
  name: string;
  description: string;
  to: string;
  route: string;
  profiles: string[];
}
export const ModuleMenuItem = (props: ModuleMenuItemProps) => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [moduleActions, setModuleActions] = useState<IModuleActions[]>([]);
  const profile = localStorage.getItem("profile") || "";
  const modules: any = [
    {
      displayName: "Lojas",
      description: "Lojas",
      icon: <Store color="info" />,
      route: "/store-list",
      profiles: ["FR", "ADMIN"],
    },

    {
      displayName: "Utilizadores",
      description: "Utilizadores",
      icon: <People color="warning" />,
      route: "/user-list",
      profiles: ["ADMIN"],
    },
    {
      displayName: "Estornos",
      description: "Estornos",
      icon: <SupportAgent color="error" />,
      route: "/reversal",
      profiles: ["FR", "ADMIN", "N1", "N2", "N3",'GECR'],
    },
  ];
  useEffect(() => {
    setModuleActions(
      modules.map((item: any) => ({
        icon: item.icon,
        name: item.displayName,
        description: item.description,
        to: `${item.displayName.toLowerCase()}`,
        route: item.route,
        profiles: item.profiles,
      }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (moduleActions.find((f) => f.to.includes(location.pathname)))
      setOpen(true);
  }, [moduleActions, location.pathname]);

  return (
    <Box
      sx={{
        bgcolor: open
          ? theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.08)"
            : "rgb(246,247,249)"
          : null,
        pb: open ? 2 : 0,
        m: 2,
        borderRadius: 2,
      }}
    >
      {open
        ? moduleActions.map((item, index) =>
            item.profiles.find((p) => profile.includes(p)) ? (
              <React.Fragment key={index}>
                <ListItemButton
                  sx={{ p: 1, minHeight: 32 }}
                  selected={location.pathname.includes(item.to)}
                  onClick={() => {
                    navigate(item.route);
                    props.closeMenu && props.handleDrawerClose();
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText
                    primary={item.name}
                    primaryTypographyProps={{
                      fontSize: 14,
                      fontWeight: "medium",
                      color: location.pathname.includes(item.to)
                        ? theme.palette.mode === "dark"
                          ? "primary"
                          : "#1976d2"
                        : "inherit",
                    }}
                  />
                </ListItemButton>
                <Divider />
              </React.Fragment>
            ) : null
          )
        : open && (
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ mt: 2 }}
            ></Stack>
          )}
    </Box>
  );
};
